// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-96e3ab0e] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.widget-custom[data-v-96e3ab0e] {
  width: 100%;
  margin: auto;
  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);
  margin-top: calc(var(--default-grid-baseline, 4px) * 3);
  overflow: hidden;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-container);
  background-color: transparent;
  display: flex;
  position: relative;
}
.widget-custom.full-width[data-v-96e3ab0e] {
  width: var(--widget-full-width, 100%) !important;
  inset-inline-start: calc((var(--widget-full-width, 100%) - 100%) / 2 * -1);
  position: relative;
}
.widget-custom__content[data-v-96e3ab0e] {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.widget-custom__resize-handle[data-v-96e3ab0e] {
  position: absolute;
  bottom: 0;
  inset-inline-start: 0;
  width: 100%;
  height: calc(var(--default-grid-baseline) * 2);
  border-top: 1px solid var(--color-border);
  margin-top: -1px;
  cursor: row-resize;
  touch-action: none;
}
.widget-custom__resize-handle[data-v-96e3ab0e]::before, .widget-custom__resize-handle[data-v-96e3ab0e]::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  background-color: var(--color-border);
  margin-top: 1px;
  transform: translateX(-50%);
  width: 30px;
  height: 1px;
}
.widget-custom__resize-handle[data-v-96e3ab0e]::before {
  margin-top: -2px;
}
.widget-custom__resize-handle[data-v-96e3ab0e]:focus-visible {
  outline: 2px solid var(--color-primary-element);
  outline-offset: -4px;
}
.widget-access[data-v-96e3ab0e] {
  width: 100%;
  margin: auto;
  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);
  margin-top: calc(var(--default-grid-baseline, 4px) * 3);
  overflow: hidden;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-container);
  background-color: transparent;
  display: flex;
  padding: calc(var(--default-grid-baseline, 4px) * 3);
}
.widget-default[data-v-96e3ab0e] {
  width: 100%;
  margin: auto;
  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);
  margin-top: calc(var(--default-grid-baseline, 4px) * 3);
  overflow: hidden;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-container);
  background-color: transparent;
  display: flex;
}
.widget-default--compact[data-v-96e3ab0e] {
  flex-direction: column;
}
.widget-default--compact .widget-default--image[data-v-96e3ab0e] {
  width: 100%;
  height: 150px;
}
.widget-default--compact .widget-default--details[data-v-96e3ab0e] {
  width: 100%;
  padding-top: calc(var(--default-grid-baseline, 4px) * 2);
  padding-bottom: calc(var(--default-grid-baseline, 4px) * 2);
}
.widget-default--compact .widget-default--description[data-v-96e3ab0e] {
  display: none;
}
.widget-default--image[data-v-96e3ab0e] {
  width: 40%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.widget-default--name[data-v-96e3ab0e] {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: var(--font-weight-heading, bold);
}
.widget-default--details[data-v-96e3ab0e] {
  padding: calc(var(--default-grid-baseline, 4px) * 3);
  width: 60%;
}
.widget-default--details p[data-v-96e3ab0e] {
  margin: 0;
  padding: 0;
}
.widget-default--description[data-v-96e3ab0e] {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.widget-default--link[data-v-96e3ab0e] {
  color: var(--color-text-maxcontrast);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.toggle-interactive[data-v-96e3ab0e] {
  position: relative;
}
.toggle-interactive .toggle-interactive--button[data-v-96e3ab0e] {
  position: absolute;
  bottom: var(--default-grid-baseline);
  inset-inline-end: var(--default-grid-baseline);
  z-index: 10000;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcReferenceWidget-Cg4xOL_8.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0DAA0D;EAC1D,uDAAuD;EACvD,gBAAgB;EAChB,qCAAqC;EACrC,6CAA6C;EAC7C,6BAA6B;EAC7B,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,gDAAgD;EAChD,0EAA0E;EAC1E,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,WAAW;EACX,8CAA8C;EAC9C,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,2BAA2B;EAC3B,WAAW;EACX,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,+CAA+C;EAC/C,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0DAA0D;EAC1D,uDAAuD;EACvD,gBAAgB;EAChB,qCAAqC;EACrC,6CAA6C;EAC7C,6BAA6B;EAC7B,aAAa;EACb,oDAAoD;AACtD;AACA;EACE,WAAW;EACX,YAAY;EACZ,0DAA0D;EAC1D,uDAAuD;EACvD,gBAAgB;EAChB,qCAAqC;EACrC,6CAA6C;EAC7C,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,wDAAwD;EACxD,2DAA2D;AAC7D;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,6CAA6C;AAC/C;AACA;EACE,oDAAoD;EACpD,UAAU;AACZ;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,8CAA8C;EAC9C,cAAc;AAChB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-96e3ab0e] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.widget-custom[data-v-96e3ab0e] {\n  width: 100%;\n  margin: auto;\n  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);\n  margin-top: calc(var(--default-grid-baseline, 4px) * 3);\n  overflow: hidden;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-container);\n  background-color: transparent;\n  display: flex;\n  position: relative;\n}\n.widget-custom.full-width[data-v-96e3ab0e] {\n  width: var(--widget-full-width, 100%) !important;\n  inset-inline-start: calc((var(--widget-full-width, 100%) - 100%) / 2 * -1);\n  position: relative;\n}\n.widget-custom__content[data-v-96e3ab0e] {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.widget-custom__resize-handle[data-v-96e3ab0e] {\n  position: absolute;\n  bottom: 0;\n  inset-inline-start: 0;\n  width: 100%;\n  height: calc(var(--default-grid-baseline) * 2);\n  border-top: 1px solid var(--color-border);\n  margin-top: -1px;\n  cursor: row-resize;\n  touch-action: none;\n}\n.widget-custom__resize-handle[data-v-96e3ab0e]::before, .widget-custom__resize-handle[data-v-96e3ab0e]::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  background-color: var(--color-border);\n  margin-top: 1px;\n  transform: translateX(-50%);\n  width: 30px;\n  height: 1px;\n}\n.widget-custom__resize-handle[data-v-96e3ab0e]::before {\n  margin-top: -2px;\n}\n.widget-custom__resize-handle[data-v-96e3ab0e]:focus-visible {\n  outline: 2px solid var(--color-primary-element);\n  outline-offset: -4px;\n}\n.widget-access[data-v-96e3ab0e] {\n  width: 100%;\n  margin: auto;\n  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);\n  margin-top: calc(var(--default-grid-baseline, 4px) * 3);\n  overflow: hidden;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-container);\n  background-color: transparent;\n  display: flex;\n  padding: calc(var(--default-grid-baseline, 4px) * 3);\n}\n.widget-default[data-v-96e3ab0e] {\n  width: 100%;\n  margin: auto;\n  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);\n  margin-top: calc(var(--default-grid-baseline, 4px) * 3);\n  overflow: hidden;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-container);\n  background-color: transparent;\n  display: flex;\n}\n.widget-default--compact[data-v-96e3ab0e] {\n  flex-direction: column;\n}\n.widget-default--compact .widget-default--image[data-v-96e3ab0e] {\n  width: 100%;\n  height: 150px;\n}\n.widget-default--compact .widget-default--details[data-v-96e3ab0e] {\n  width: 100%;\n  padding-top: calc(var(--default-grid-baseline, 4px) * 2);\n  padding-bottom: calc(var(--default-grid-baseline, 4px) * 2);\n}\n.widget-default--compact .widget-default--description[data-v-96e3ab0e] {\n  display: none;\n}\n.widget-default--image[data-v-96e3ab0e] {\n  width: 40%;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.widget-default--name[data-v-96e3ab0e] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: var(--font-weight-heading, bold);\n}\n.widget-default--details[data-v-96e3ab0e] {\n  padding: calc(var(--default-grid-baseline, 4px) * 3);\n  width: 60%;\n}\n.widget-default--details p[data-v-96e3ab0e] {\n  margin: 0;\n  padding: 0;\n}\n.widget-default--description[data-v-96e3ab0e] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n.widget-default--link[data-v-96e3ab0e] {\n  color: var(--color-text-maxcontrast);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.toggle-interactive[data-v-96e3ab0e] {\n  position: relative;\n}\n.toggle-interactive .toggle-interactive--button[data-v-96e3ab0e] {\n  position: absolute;\n  bottom: var(--default-grid-baseline);\n  inset-inline-end: var(--default-grid-baseline);\n  z-index: 10000;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
